import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, useContext } from 'react';
import $ from 'jquery';
import moment from 'moment';
import FilterContext from "../../utils/FilterContext";


const DateRangePicker = forwardRef(({ onDateChange, config = {}, ...props }, ref) => {
    const { filters } = useContext(FilterContext);
    const filtersRef = useRef(filters);
    const pickerRef = useRef(null);
    const [placeholder, setPlaceholder] = useState('Select a date range'); // Custom placeholder

    //  Listen for changes in the global filters and reset the corresponding local state if necessary.
    // useEffect(() => {
    //     if (!filters.dateRange) {
    //         setPlaceholder(null);
    //     }

    // }, [filters]);

    // Initialize with saved filter values
    useEffect(() => {
        const $picker = $(pickerRef.current);
        const drp = $picker.data('daterangepicker');

        if (filters.dateRange) {
            // Set placeholder and input value
            setPlaceholder(filters.dateRange);
            $picker.val(filters.dateRange);

            // Parse and set date range in calendar
            const [startStr, endStr] = filters.dateRange.split(' - ');
            const startDate = moment(startStr, 'YYYY-MM-DD');
            const endDate = moment(endStr, 'YYYY-MM-DD');

            if (drp && startDate.isValid() && endDate.isValid()) {
                drp.setStartDate(startDate);
                drp.setEndDate(endDate);
            }
        } else {
            // Reset if empty
            setPlaceholder("Select a date range");
            $picker.val('');
            if (drp) {
                const today = moment();
                drp.setStartDate(today);
                drp.setEndDate(today);
            }
        }
    }, [filters.dateRange]);



    useImperativeHandle(ref, () => ({
        // Expose reset function to parent component
        resetSelections() {
            const $picker = $(pickerRef.current);
            $picker.val(''); // Clear input value
            setPlaceholder('Select a date range'); // Reset placeholder
        },
        // get function to parent component
        getSelectedData() {
            return { dateRange: placeholder !== 'Select a date range' ? placeholder : null };
        }

    }));
    useEffect(() => {
        const $picker = $(pickerRef.current);

        // $picker.daterangepicker(
        //     {
        //         locale: {
        //             format: 'YYYY-MM-DD',
        //             cancelLabel: 'Clear',
        //         },
        //         ranges: {
        //             'Today': [moment(), moment()],
        //             'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        //             'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        //             'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        //             'Last Week': [
        //                 moment().subtract(1, 'week').startOf('week'),
        //                 moment().subtract(1, 'week').endOf('week')
        //             ],
        //             'This Month': [moment().startOf('month'), moment().endOf('month')],
        //             'Last Month': [
        //                 moment().subtract(1, 'month').startOf('month'),
        //                 moment().subtract(1, 'month').endOf('month')
        //             ],

        //         }
        //     },
        //     (start, end, label) => {
        //         if (label === 'Manual' || !start || !end) {
        //             setPlaceholder('Select a date range');
        //             if (onDateChange) onDateChange(null);
        //             return;
        //         }

        //         const formattedStart = start.format('YYYY-MM-DD');
        //         const formattedEnd = end.format('YYYY-MM-DD');
        //         setPlaceholder(`${formattedStart} - ${formattedEnd}`);
        //         if (onDateChange) {
        //             onDateChange({ start: formattedStart, end: formattedEnd });
        //         }
        //     }
        // );

        const defaultConfig = {
            locale: {
                format: 'YYYY-MM-DD',
                cancelLabel: 'Clear',
            },
            ranges: {
                Today: [moment(), moment()],
                Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [
                    moment().subtract(1, 'month').startOf('month'),
                    moment().subtract(1, 'month').endOf('month'),
                ],
            },
        };

        const mergedConfig = {
            ...defaultConfig,
            ...config, // Override or add custom options
            locale: {
                ...defaultConfig.locale,
                ...(config.locale || {}),
            },
            ranges: config.ranges || defaultConfig.ranges,
        };

        $picker.daterangepicker(mergedConfig, (start, end, label) => {
            console.log("Selected:", start.format(), end.format(), label); // 🔍 This should show when selecting
            if (label === 'Manual' || !start || !end) {
                setPlaceholder('Select a date range');
                onDateChange?.(null);
                return;
            }

            const formattedStart = start.format(mergedConfig.locale.format);
            const formattedEnd = end.format(mergedConfig.locale.format);
            setPlaceholder(`${formattedStart} - ${formattedEnd}`);
            onDateChange?.({ start: formattedStart, end: formattedEnd });
        });

        $picker.on('cancel.daterangepicker', function () {
            setPlaceholder('Select a date range');
            $picker.val('');
        });

        return () => {
            $picker.data('daterangepicker').remove();
        };
    }, []);


    return (
        <div>
            <input
                type="text"
                ref={pickerRef}
                className=" w-100"
                readOnly
                placeholder={placeholder} // Dynamically set placeholder
                style={{ padding: '7px' }}
            />

        </div>
    );
});

export default DateRangePicker;
